var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2488_1588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 18,
    height: 18,
    transform: "rotate(-180 18 18)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2488_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52981 8.43748L14.0625 8.43748C14.2221 8.43748 14.3558 8.49132 14.4635 8.59901C14.5712 8.7067 14.625 8.84035 14.625 8.99996C14.625 9.15957 14.5712 9.29322 14.4635 9.40091C14.3558 9.5086 14.2221 9.56244 14.0625 9.56244L5.52981 9.56244L9.40674 13.4394C9.51828 13.5509 9.57332 13.6814 9.57187 13.831C9.57044 13.9805 9.51154 14.1134 9.39519 14.2297C9.27886 14.3384 9.14713 14.3946 9.00002 14.3985C8.85291 14.4023 8.72118 14.3461 8.60484 14.2297L3.84956 9.47446C3.77938 9.40428 3.72986 9.33024 3.70101 9.25235C3.67215 9.17448 3.65773 9.09035 3.65773 8.99996C3.65773 8.90957 3.67215 8.82544 3.70101 8.74756C3.72986 8.66968 3.77938 8.59564 3.84956 8.52545L8.60484 3.77017C8.70868 3.66632 8.83728 3.61319 8.99064 3.61079C9.14401 3.6084 9.27886 3.66152 9.39519 3.77017C9.51154 3.88651 9.56972 4.02016 9.56972 4.17112C9.56972 4.32208 9.51154 4.45573 9.39519 4.57207L5.52981 8.43748Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow_prev.ff44689c9df166e5204b6b3409b86c23.svg";
export { ForwardRef as ReactComponent };